import { CommonModule } from '@angular/common'
import { Component, computed, Inject, signal, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-delete-dialog',
  templateUrl: './ddc-delete-dialog.component.html',
  styleUrls: ['./ddc-delete-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcDeleteDialogComponent {
  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  _theme: string
  private themeSubscription: Subscription

  _isEditBtnLoading = false
  _submitBtnText = 'Edit'
  _maxLength: number = 100
  _editError: string = ''
  _editedField: string = ''

  _type: string = ''
  _element: any = undefined
  _hasDic: boolean = false
  _closeBtnCommand: string = ''

  _elementSignal = signal<any>(this._element)

  elementLabel = computed(() => {
    const element = this._elementSignal()
    return element?.label
      ? element.label
      : element?.word
        ? element.word
        : element?.word_1 && element?.word_2
          ? element.word_1.word + '-' + element.word_2.word
          : element?.name
  })

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
    private dialogRef: MatDialogRef<DdcDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this._type = data.type
    this._closeBtnCommand = 'delete-element'
    this._element = data.element
    this._elementSignal.set(this._element)
    if (data.hasDic) this._hasDic = data.hasDic

    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
}
